import React from 'react'
import { SkeletonElement } from '@notino/react-styleguide'

// types
import { ReservationCardProps, ReservationCardSkeletonProps } from './types'

// utils
import { RESERVATION_STATE } from '../../utils/enums'
import { formatRelativeDate, getEmployeeName, isEnumValue } from '../../utils/helper'

// hooks
import useMessages from '../../hooks/useMessages'

// components
import ReservationStatusBadge from '../ReservationStatusBadge/ReservationStatusBadge'

// styles
import * as SC from './ReservationCardStyles'

export const ReservationCardSkeleton = (props: ReservationCardSkeletonProps) => {
	const { cardStyle = 'future', mobileBreakpoint = 'lg' } = props
	return (
		<SC.ReservationCardContainer $breakpoint={mobileBreakpoint} $cardStyle={cardStyle} as={'div'} $isSkeleton>
			<SC.ReservationStatusContainer $breakpoint={mobileBreakpoint}>
				<SkeletonElement width={'4.5rem'} height={'1.5rem'} animated />
			</SC.ReservationStatusContainer>
			<SC.SalonName $breakpoint={mobileBreakpoint}>
				<SkeletonElement width={'16rem'} height={'80%'} animated />
			</SC.SalonName>
			<SC.DateTime $breakpoint={mobileBreakpoint}>
				<SkeletonElement width={'8rem'} height={'1.25rem'} animated />
			</SC.DateTime>
			<SC.ServiceAndEmployeeContainer>
				<SkeletonElement width={'3.5rem'} height={'1.25rem'} animated />
				<SkeletonElement width={'3.5rem'} height={'1.25rem'} animated />
			</SC.ServiceAndEmployeeContainer>
		</SC.ReservationCardContainer>
	)
}

const ReservationCard = (props: ReservationCardProps) => {
	const { messages } = useMessages()

	const { reservationData, cardStyle = 'future', mobileBreakpoint = 'lg', href } = props
	const {
		state,
		calendarEvent: { employee, salon, service, start, end }
	} = reservationData

	const employeeName = getEmployeeName(employee)

	return (
		<SC.ReservationCardContainer $breakpoint={mobileBreakpoint} $cardStyle={cardStyle} href={href}>
			{isEnumValue(state, RESERVATION_STATE) && (
				<SC.ReservationStatusContainer $breakpoint={mobileBreakpoint}>
					<ReservationStatusBadge reservationState={state} size={'small'} />
				</SC.ReservationStatusContainer>
			)}
			<SC.SalonName $breakpoint={mobileBreakpoint}>{salon.name}</SC.SalonName>
			<SC.DateTime $breakpoint={mobileBreakpoint}>{`${formatRelativeDate(start.date)}, ${start.time} - ${end.time}`}</SC.DateTime>
			<SC.ServiceAndEmployeeContainer>
				{service?.name && <SC.ServiceName>{service.name}</SC.ServiceName>}
				{service?.name && <SC.EmployeeDivider />}
				<SC.EmployeeContainer>
					<img src={employee.image.resizedImages.thumbnail} alt={messages['Employee avatar']} />
					{employeeName && <SC.EmployeeName>{employeeName}</SC.EmployeeName>}
				</SC.EmployeeContainer>
			</SC.ServiceAndEmployeeContainer>
		</SC.ReservationCardContainer>
	)
}

export default ReservationCard
